import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
import Form from 'react-bootstrap/Form';

import MapAndMarkers from './MapAndMarkers.js';
import ListingCard from './ListingCard';

const styles = theme => ({
  root: {
    justifyContent: 'flex-start',
    height: '100%',
    width: '100%',
    display: 'block',
    overflow: 'hidden',
  },
  mapDiv: {
    height: '100%',
    width: '50%',
    display: 'inline-block',
    position: 'sticky',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  listGridDiv: {
    overflow: 'auto',
    height: '85vh',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  parentDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%',
    overflow: 'hidden',
  },
  subTitleDiv: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: 15,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  subtitle: {
    marginTop: '35px',
  },
  planeIcon: {
    color: '#F44436',
    marginTop: 15,
    marginRight: 15,
    fontSize: 35,
  },
  paginationSection: {
    height: '100px',
    margin: 50,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
});

class ListingsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredListingId: null,
      mapSize: null,
    };
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page,
    });
  };

  handleListingEnter = listing => {
    this.setState({
      hoveredListingId: listing.mlsNumber,
    });
  };

  handlingListingLeave = () => {
    this.setState({
      hoveredListingId: null,
    });
  };

  handleMarkerClick = mlsNumber => {
    const url = `/listings/detail/${mlsNumber}`;
    window.location = url;
  };

  setMapSize = mapSize => {
    this.setState({ mapSize });
  };

  render() {

    const {
      listings,
      listingFilter,
      updateFilter,
      classes,
      mapShowing,
      isLoading,
      toggleMapShowing,
    } = this.props;

    const loadingSpinner = (
      <FadeLoader sizeUnit="px" size={300} color="#4A90E2" />
    );

    const width = mapShowing ? '50%' : '100%';
    const mapButtonText = mapShowing ? 'Hide Map' : 'Show Map';
    const hasListings = listings.length > 0;

    return (
      <LoadingOverlay active={isLoading} spinner={loadingSpinner}>
        <div id="searchPageContainer" className="flexbox-container" style={{ paddingTop: '255px' }}>
          <div className="col-12 text-right py-2 hide-print">
            <button
            className="form-control col-1 pull-right"
            onClick={toggleMapShowing}>{mapButtonText}</button>
          </div>
          <div id="left_container" className="leftContainer" style={{'width':width}}>
            <div className="containerContent">
              <div className="row mt-4">
                <div className="col-auto mr-auto pt-2 px-4">
                  Showing {listings.length} homes
                  { !hasListings && (
                    <div className="pt-2">
                      <b>Refine your search to find properties</b>
                    </div>
                  )}
                </div>
                { hasListings && (<div className="col-auto hide-print">
                  <Form.Check
                    type="checkbox"
                    label="Hobson Listings Only"
                    style={{ paddingTop: '8px', paddingRight: '15px' }}
                    checked={listingFilter.hobsonOnly}
                    onChange={e => {
                      updateFilter({
                        hobsonOnly: e.target.checked ? 1 : 0,
                      });
                    }}
                  />
                </div>)}
                { hasListings && (<div className="col-auto hide-print">
                  <select
                    className="custom-select mr-sm-4 float-right"
                    value={listingFilter.sort}
                    onChange={e => updateFilter({ sort: e.target.value })}
                  >
                    <option value="price-desc">Price High to Low</option>
                    <option value="price-asc">Price Low to High</option>
                    <option value="daysOnMarket-asc">Newest to Oldest</option>
                    <option value="daysOnMarket-desc">Oldest to Newest</option>
                  </select>
                </div>)}
              </div>
              <div className="listing-cards">
                <div className="cards-wrapper" section="GridView">
                  <div className="cards">
                    {listings.map((listing, i) => (
                      <ListingCard
                        id={i}
                        key={i}
                        listing={listing}
                        mapShowing={mapShowing}
                        openInNewWindow
                        handleListingEnter={this.handleListingEnter}
                        handleListingLeave={() =>
                          this.handlingListingLeave(listing.mlsNumber)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {mapShowing && (
            <div className={classes.mapDiv} id="listingsMap">
              <MapAndMarkers
                listingFilter={listingFilter}
                updateFilter={updateFilter}
                setMapSize={this.setMapSize}
                mapSize={this.state.mapSize}
                listings={listings}
                hoveredListingId={this.state.hoveredListingId}
                handleMarkerClick={this.handleMarkerClick}
              />
            </div>
          )}
        </div>
      </LoadingOverlay>
    );

    /* return (
      <div className={classes.root}>
        <div className={classes.parentDiv}>
          <Grid
            container
            className=""
            justify={mapShowing ? 'flex-start' : 'space-evenly'}
            spacing={0}
          >
            <div className={classes.subTitleDiv}>
              <FlightTakeoff color="secondary" className={classes.planeIcon} />
              <Typography
                variant="subtitle1"
                className={classes.subtitle}
                gutterBottom
              >
                Explore and Filter the New York Times recommended travel
                destinations since 2011.
              </Typography>
            </div>

            {listings.map(listing => (
              <Grid key={listing.mlsNumber} item>
                <ListingCard
                  setCardMarkerHover={this.setCardMarkerHover}
                  resetCardMarkerHover={this.resetCardMarkerHover}
                  listing={listing}
                />
              </Grid>
            ))}
          </Grid>

          {mapShowing && (
            <div className={classes.mapDiv}>
              <MapAndMarkers
                listings={listings}
                hoveredCardId={this.state.hoveredCardId}
              />
            </div>
          )}
        </div>
      </div>
    ); */
  }
}

ListingsGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListingsGrid);
